import React, { useState, useEffect } from "react";
import api from "@/services/api";
import { ShoppingCart } from "lucide-react";

export default function VendedorHistorial() {
  const [ventas, setVentas] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchVentas();
  }, []);

  const fetchVentas = async () => {
    try {
      const response = await api.get("/ventas");
      setVentas(response.data);
    } catch (error) {
      console.error("Error fetching ventas:", error);
    } finally {
      setLoading(false);
    }
  };

  const formatCurrency = (value) => {
    return new Intl.NumberFormat("es-CO", {
      style: "currency",
      currency: "COP",
      minimumFractionDigits: 0,
    }).format(value);
  };

  const formatDate = (dateStr) => {
    return new Date(dateStr).toLocaleString("es-CO", {
      day: "2-digit",
      month: "short",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const totalVentas = ventas.reduce((sum, v) => sum + (v.total || 0), 0);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-pulse text-torta-brown">Cargando...</div>
      </div>
    );
  }

  return (
    <div className="space-y-6" data-testid="vendedor-historial">
      <div>
        <h1 className="font-display text-3xl text-torta-dark">Mis Ventas</h1>
        <p className="text-torta-muted">Historial de ventas</p>
      </div>

      {/* Summary */}
      <div className="bg-torta-brown rounded-2xl p-6 text-white">
        <p className="text-white/80 text-sm mb-1">Total Ventas</p>
        <p className="font-display text-3xl">{formatCurrency(totalVentas)}</p>
        <p className="text-white/60 text-sm mt-1">{ventas.length} transacciones</p>
      </div>

      {/* Ventas List */}
      <div className="space-y-3">
        {ventas.map((venta) => (
          <div key={venta.id} className="bg-white rounded-xl p-4 shadow-sm">
            <div className="flex items-start justify-between mb-3">
              <div>
                <p className="text-xs text-torta-muted">{formatDate(venta.fecha)}</p>
                {venta.cliente_nombre && (
                  <p className="text-sm text-torta-dark mt-1">
                    Cliente: {venta.cliente_nombre}
                  </p>
                )}
              </div>
              <div className="text-right">
                <p className="font-display text-xl text-torta-brown">
                  {formatCurrency(venta.total)}
                </p>
                <span
                  className={`inline-flex px-2 py-0.5 rounded text-xs ${
                    venta.metodo_pago === "efectivo"
                      ? "bg-green-100 text-green-700"
                      : "bg-blue-100 text-blue-700"
                  }`}
                >
                  {venta.metodo_pago}
                </span>
              </div>
            </div>

            <div className="flex flex-wrap gap-2">
              {venta.items?.map((item, i) => (
                <span
                  key={i}
                  className="inline-flex items-center gap-1 bg-torta-cream px-2 py-1 rounded text-xs text-torta-dark"
                >
                  {item.cantidad}x {item.producto_nombre}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>

      {ventas.length === 0 && (
        <div className="text-center py-12 bg-white rounded-2xl">
          <ShoppingCart className="w-12 h-12 text-torta-muted mx-auto mb-4" />
          <p className="text-torta-muted">No tienes ventas registradas</p>
        </div>
      )}
    </div>
  );
}
